import { ConversationAPI } from 'api'

export const fetchSalesforceEnrichmentByEmail = ({ email }) => {
  return ConversationAPI
    .get(`/salesforce/enrichment?email=${encodeURIComponent(email)}`)
}
